export const CloudFunctionName = {
    "generateVideocallToken": "generateVideocallToken",
    "createvideocallRoom": "createvideocallRoom",
    "createMetaUser": "createMetaUserV2",
    "updateMetaUser": "updateMetaUserV1"
}